import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import FeatureCards from './components/FeatureCards';
import WorkflowSteps from './components/WorkflowSteps';
import ComparisonSection from './components/ComparisonSection';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqItems } from '@/mocks/siteData';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.study';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Spreadsheet Study',
  url: SITE_URL,
  description: 'Independent educational resource for Basetao Spreadsheet systems. Find product research guides, shipping cost comparisons, warehouse tracking tips, discount codes, and complete spreadsheet tutorials.',
  publisher: {
    '@type': 'Organization',
    name: 'Basetao Spreadsheet Study',
    logo: {
      '@type': 'ImageObject',
      url: LOGO_URL,
    },
  },
};

const jsonLdWebPage = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Basetao Spreadsheet Study - Complete Guides, Reviews & Shopping Resources 2026',
  description: 'Independent educational resource for Basetao Spreadsheet systems. Find product research guides, shipping cost comparisons, warehouse tracking tips, discount codes, and complete spreadsheet tutorials. Updated 2026.',
  url: `${SITE_URL}/`,
  isPartOf: {
    '@type': 'WebSite',
    name: 'Basetao Spreadsheet Study',
    url: SITE_URL,
  },
  about: {
    '@type': 'Thing',
    name: 'Basetao Spreadsheet',
    description: 'A structured shopping research system that helps users organize products, compare sellers, track prices, manage warehouse information, and improve their buying workflow.',
  },
};

const jsonLdFaq = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebSite) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebPage) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFaq) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <FeatureCards />
        <WorkflowSteps />
        <ComparisonSection />
        <ArticlePreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}